<template>
    <div class="wizard-header">
        <div class="wizard-header-step">{{ currentStep }}</div>
        <div class="wizard-header-title">{{ title }}</div>
        <div class="wizard-header-progress">
            <div class="wizard-header-progress-done" :style="{width: (currentStep / stepsCount * 100) + '%'}"></div>
        </div>
        <div class="wizard-header-left">{{currentStep}}/{{stepsCount}}</div>
    </div>
</template>

<script>
export default {
    name: "WizardHeader",
    props: {
        title: {
            type: String,
            required: true
        },
        currentStep: {
            type: Number,
            required: true,
        },
        stepsCount: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.wizard-header {
    text-align: center;
    margin-bottom: 30px;

    &-step {
        width: 27px;
        height: 27px;
        border-radius: 50%;
        background-color: #5271DE;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        margin: 55px auto 0;
    }

    &-title {
        font-size: 12px;
        color: #555555;
        margin-top: 15px;
    }

    &-progress {
        background: #FFFFFF;
        border: 1px solid #FFF8F8;
        box-shadow: inset 0 2px 4px rgb(0 0 0 / 11%);
        border-radius: 40px;
        padding: 2px;
        margin: 14px auto 2px;
        width: 100%;
        max-width: 300px;
        height: 15px;

        &-done {
            background: #5271DE;
            min-width: 40px;
            height: 100%;
            border-radius: 40px;
            transition: width 0.4s ease;
        }
    }

    &-left {
        font-size: 10px;
        line-height: 14px;
        color: #555555;
    }
}
</style>
